import { Component, ElementRef, Input, OnInit } from '@angular/core';

import { environment } from '../../../environments/environment';

import { SnippetService } from '../../services/snippet.service';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'kd-document-code',
    templateUrl: './document-code.component.html',
    styleUrls: ['./document-code.component.scss']
})
export class DocumentCodeComponent implements OnInit {

    @Input()
    element: HTMLElement;

    syntax: string;
    private template: string;

    constructor(
        private elementRef: ElementRef,
        private snippetService: SnippetService,
        private userService: UserService,
    ) { }

    ngOnInit() {
        this.template = this.snippetService.cleanup(this.element.innerHTML.replace(environment.codeSnippetPrefix, ''));
        this.syntax = this.element.innerHTML.match(environment.codeSnippetPrefix)[environment.codeSnippetSyntaxMatch];

        this.initSnippet();
        this.userService.getCredentialsChange().subscribe(() => {
            this.initSnippet();
        });
    }

    private initSnippet(): Promise<void> {
        return this.snippetService.initSnippet(this.elementRef.nativeElement, '.content', this.template);
    }
}
